module.exports = __webpack_public_path__ + "img/4.62d52ba4.png";